const NAMESPACE = "crnt";

export { NAMESPACE };
